
import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import ImprimirModal from './ImprimirModal';
import auth from '../../../common/utility/auth';
import printFormatMock from "../../../common/mock/printFormatMock";


import CierreModal from '../ArqueoCaja/CerrarCaja/CierreModal';
import empleadoService from '../../../service/administracion/empleadoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import establecimientoService from '../../../service/administracion/establecimientoService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import cajaService from '../../../service/administracion/cajaService';
import cajaAperturaService from '../../../service/tesoreria/cajaAperturaService';

import arqueoCajaService from '../../../service/tesoreria/arqueoCajaService';

import AnexoModal from '../ArqueoCaja/AnexoModal';
import { TESORERIA } from '../../../common/types/moduloType';
import { VER_CAJA_COB, APER_CAJA_COB } from '../../../common/types/configuracionType';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {

            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            loadingChange: true,
            viewVisible: false,
            viewAnexo: false,

            imprimirVisible: false,
            viewCierreVisible: false,
            listaEmpleado: [],
            listaCaja: [],
            listaEstado: [],
            listaEstablecimiento: [],
            tiposCambioDiario: [],
            listaEfectivoSoles: [],
            listaEfectivoDolares: [],
            listaResumen: [],
            listaAnexo: [],
            configuraciones: [],
            serie_correlativo: {
                nroSerie: '',
                correlativo: ''

            },
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                response: undefined,

            },

            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                IdEstablecimiento: 0,
                IdCaja: 0,
                idEmpleado: 0,// auth.user().flagPermisoTS ? 0 : auth.user().id,
                IdEstado: 0,
                Id: 0,
                cajas: [],
                ...FILTER
            },
            pagination: PAGINATION,
            paginationAnexo: PAGINATION,

            visible: false,
            formValues: this.fetchEmptyFormValues()

        }
    }


    fetchEmptyFormValues = () => {
        return {
            id: 0,
            serie: "",
            idResposanbleArqueo: 0,
            correlativo: "",
            FechaTipoCambio: global.fetchCurrentDateStr(),
            TipoCambio: 0,
            establecimiento: 0,
            caja: 0,
            responsable: '',
            usuario: '',
            fechaApertura: '',
            fechaCierre: '',
            saldoSoles: 0,
            saldoDolares: 0,
            listaEmpleado: [],
            listaCaja: [],
            listaEstablecimiento: [],
            listaEfectivoSoles: [],
            listaEfectivoDolares: [],
            listaResumen: [],
            listaAjuste: [],
            listaAnexo: [],
        }
    };


    //#region FILTER

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value, name, valor) => {
        const filter = { ...this.state.filter, [property]: value };
        if (property === 'IdEstablecimiento') {
            filter.cajas = this.state.listaCaja.filter(m => m.iD_Establecimiento === value && m.idTipoCaja == 1);
            filter.IdCaja = 0;
        }
        if (name !== undefined) {

            switch (name) {
                case 'establecimiento':
                    filter.establecimiento = valor;
                    break;
                case 'caja':
                    filter.caja = valor;
                    break;
                case 'empleado':
                    filter.empleado = valor;
                    break;
                case 'estado':
                    filter.estado = valor;
                    break;
            }
        }

        this.setState({ filter });


    };

    handleClearFilters = () => {
        var filter = {

            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            establecimiento: 0,
            idEmpleado: 0,// auth.user().flagPermisoTS ? 0 : auth.user().id,
            caja: 0,
            responsable: 0,
            estado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };




    //#endregion END  FILTER

    //#region RESULT-LIST

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cajaAperturaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Caja Apertura.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cajaAperturaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Caja Apertura.pdf");
    }




    handleDownloadPdf = async () => {
        global.dowloadFile(this.state.imprimirFormValues.response.data, "CIERRE CAJA " + this.state.selectedItem.nroSerie_correlativo + ".pdf"
        );

    };



    handleChangeImprimir = async (idFormato) => {
        debugger
        var file = undefined;
        var response = undefined;
        var id = this.state.imprimirFormValues.idComprobante;
        if (idFormato === 1) {
            response = await cajaAperturaService.pdfPrint(id);
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cajaAperturaService.pdfTicket(id);
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
            },
        });
    };




    handleImprimir = async (item) => {

        this.setState({ loadingPrint: true });
        var file = undefined;
        var response = undefined;
        var idFormato = 1; //pdf

        if (idFormato === 1) {
            response = await cajaAperturaService.pdfPrint(item.id);
            file = window.URL.createObjectURL(response.data);
        }



        this.setState({
            loadingPrint: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idComprobante: item.id,
                response,
            },
            selectedItem: item
        });
    };


    handleExportExcelAnexo = async () => {
        this.setState({ loadingExcel: true });

        var response = this.state.formValues;
        var data = new Object();
        data.id = response.id;
        data.nroSerie = response.serie;
        data.correlativo = response.correlativo;

        data.establecimiento = response.establecimiento;
        data.empleado = response.empleado;
        data.caja = response.caja;
        data.tipoCambio = response.TipoCambio;
        data.fechaApertura = response.fechaApertura;
        data.fechaCierre = response.fechaCierre;

        switch (response.idCajaEstado) {
            case 1: //registado
                data.estado = "REGISTRADO";
                break;
            case 2://ANULADA
                data.estado = "ANULADA";
                break;
            case 3://APERTURADA
                data.estado = "APERTURADA";
                break;
            case 4://CERRADO
                data.estado = "CERRADO";
                break;
            case 5://POR CERRAR
                data.estado = "POR CERRAR";
                break;
            default:
                data.estado = "";

        }


        var response = await arqueoCajaService.excelAnexo(data);

        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Anexo.xlsx");
    }


    handleAnexo = async (item) => {

        var response = item;
        const filter = { ...this.state.filter, Id: item.id };

        var response_anexo = await arqueoCajaService.obtenerAnexoId(filter);


        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues();
            formValues.id = response.id;
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.serie = response.nroSerie;
            formValues.establecimiento = response.establecimiento;
            formValues.empleado = response.empleado;
            formValues.caja = response.caja;
            formValues.responsable = response.empleado;
            formValues.usuario = response.nroEmpleado;
            formValues.idCajaEstado = response.idCajaEstado;
            formValues.fechaApertura = response.fecha + '-' + response.hora;
            formValues.fechaCierre = response.fechaCierre + '-' + response.horaCierre;
            formValues.correlativo = response.correlativo;
            formValues.listaAnexo = response_anexo ? response_anexo.data : [];
        }

        this.setState({
            viewAnexo: true,
            formValues,
            filter,
            paginationAnexo: response_anexo

        });
    };



    //#endregion END  RESULT-LIST



    //#region REGISTRO NUEVO
    handleNew = async () => {

        var usuarioId = auth.user().id;
        var usuario = auth.user().nombre + ' ' + auth.user().apellidoMaterno + ' ' + auth.user().apellidoPaterno;

        const seriecorrelativo = await cajaAperturaService.Getcorrelativo();
        var formValues = this.fetchEmptyFormValues();
        formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
        formValues.TipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
        formValues.idResponsable = usuarioId;

        formValues.listaEmpleado = [{ 'id': usuarioId, 'nombre': usuario }];

        formValues.serie = seriecorrelativo.nroSerie;

        formValues.correlativo = seriecorrelativo.correlativo;

        this.setState({ visible: true, formValues });


    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };



    handleCerrarCaja = (values, valuesAjuste, form) => {


        /*         if (!auth.user().flagPermisoCaja) {
        
                    dialog.error('El Usuario ' + auth.user().nombre + ' no tiene permiso como responsable de caja');
                    return false
                } */


        var total_Soles = values.filter(value => value.cantidad > 0 && value.id_Moneda == 1).reduce((a, b) => a + (b["total"] || 0), 0); //soles
        var total_Dolares = values.filter(value => value.cantidad > 0 && value.id_Moneda == 2).reduce((a, b) => a + (b["total"] || 0), 0); //dolares

        var totalSoles_Resumen = valuesAjuste.filter(m => m.moneda == 'SOLES').reduce((a, b) => a + (b["totalEfectivo"] || 0), 0);
        var totalDolares_Resumen = valuesAjuste.filter(m => m.moneda != 'SOLES').reduce((a, b) => a + (b["totalEfectivo"] || 0), 0);


        var totalSoles_Faltante = valuesAjuste.filter(m => m.moneda == 'SOLES').reduce((a, b) => a + (b["totalfaltante"] || 0), 0);
        var totalDolares_Faltante = valuesAjuste.filter(m => m.moneda != 'SOLES').reduce((a, b) => a + (b["totalfaltante"] || 0), 0);

        //cuando hay documentos de venta
        if (this.state.formValues.listaResumen.length > 0) {

            /*         total_Soles = parseFloat(total_Soles) - (parseFloat(totalSoles_Faltante.toFixed(2)));
                    total_Dolares = parseFloat(total_Dolares) - (parseFloat(totalDolares_Faltante.toFixed(2)));
        
                    if (totalSoles_Resumen != total_Soles) {
                        dialog.error('El monto total en Soles de las ventas realizadas debe ser igual con el monto de arqueo');
                        return false
                    }
                    if (totalDolares_Resumen != total_Dolares) {
                        dialog.error('El monto total en Dolares de las ventas realizadas debe ser igual con el monto de arqueo');
                        return false
                    }
         */

            total_Soles = parseFloat(total_Soles) - parseFloat(totalSoles_Faltante.toFixed(2));
            total_Dolares = parseFloat(total_Dolares) - parseFloat(totalDolares_Faltante.toFixed(2));

            const tolerancia = 0.09;

            // Validar diferencia en soles
            if (Math.abs(totalSoles_Resumen - total_Soles) > tolerancia) {
                dialog.error('El monto total en Soles de las ventas realizadas debe ser igual con el monto de arqueo (diferencia permitida: 0.09)');
                return false;
            }

            // Validar diferencia en dólares
            if (Math.abs(totalDolares_Resumen - total_Dolares) > tolerancia) {
                dialog.error('El monto total en Dólares de las ventas realizadas debe ser igual con el monto de arqueo (diferencia permitida: 0.09)');
                return false;
            }



        }
        // cuando no hay documentos de venta pero solo  cuadrar saldo inicial

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            var FilterValues = values.filter(value => value.cantidad > 0);

            if (FilterValues.length == 0) {
                var detalleProductos = {
                    id_CajaApertura: this.state.formValues.id,
                    abreviatura: "S/",
                    cantidad: 0,
                    formato: "Moneda",
                    id: 0,
                    id_Moneda: 0,
                    monto: 0,
                    total: 0
                };
                FilterValues.push(detalleProductos);
            }
            response = await cajaAperturaService.registrarCaja_Cierre(FilterValues);

            if (valuesAjuste.length > 0)
                var response1 = await arqueoCajaService.registrarCajaAjuste(valuesAjuste);

            if (response.status === 200) {
                form.resetFields();
                this.setState({
                    viewCierreVisible: false,
                });
                message.success(('Registrado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    ChangePagination = async (pagination) => {
        debugger

        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter: filter });

        this.setState({
            formValues: {
                ...this.state.formValues,
                paginationAnexo: null,

            }
        });

        setTimeout(() => {
            this.ChangePaginationGetData();
        }, 100);

    }


    ChangePaginationGetData = async () => {
        var response = undefined;

        if (this.state.filter.Id == 0) {
            response = await arqueoCajaService.pagination({ ...this.state.filter });

            this.setState({
                pagination: response,
            })
        } else {
            response = await arqueoCajaService.obtenerAnexoId({ ...this.state.filter });

            this.setState({
                paginationAnexo: response
            });

        }


    }
    //#endregion END  REGISTRO NUEVO

    //#region VIEW



    handleViewCierre = async (item) => {

        var flagAperturar = this.state.configuraciones.filter((m) => m.abreviatura === APER_CAJA_COB).length >= 1 ? true : false;
        if (!flagAperturar) {
            message.warning('Usted no puede aperturar la cobranza.');
            return;
        }

        var response = await cajaAperturaService.obtenerPorId(item.id);
        var response_resumen = await cajaAperturaService.obtenerResumenId(item.id);

        if (response !== undefined) {


            var formValues = this.fetchEmptyFormValues();
            formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
            formValues.TipoCambio = response.tipoCambio;
            formValues.FechaTipoCambio = response.fecha;
            formValues.listaCaja = this.state.listaCaja ? this.state.listaCaja : [];
            formValues.listaEmpleado = this.state.listaEmpleado ? this.state.listaEmpleado : [];
            formValues.id = item.id;
            formValues.serie = response.nroSerie;
            formValues.idEstablecimiento = response.iD_Establecimiento;
            formValues.idResponsable = response.iD_Empleado;
            formValues.idCaja = response.iD_Caja;
            formValues.responsable = response.empleado;
            formValues.usuario = response.nroEmpleado;

            formValues.saldoSoles = response.saldoInicialSoles;
            formValues.saldoDolares = response.saldoInicialDolares;
            formValues.listaResumen = response_resumen ? response_resumen : [];

            formValues.correlativo = response.correlativo;

            formValues.listaEfectivoSoles = this.state.listaEfectivoSoles;
            formValues.listaEfectivoDolares = this.state.listaEfectivoDolares;

            var totalSoles = 0;
            var totalDolares = 0;


            if (formValues.listaResumen.length > 0) {
                totalSoles = formValues.listaResumen.filter(value => value.moneda == "SOLES" && value.metodoPago.toLowerCase() == "efectivo").reduce((a, b) => a + (b["total"] || 0), 0)
                totalDolares = formValues.listaResumen.filter(value => value.moneda != "SOLES" && value.metodoPago.toLowerCase() == "efectivo").reduce((a, b) => a + (b["total"] || 0), 0)
            }

            var data_totalSoles = formValues.listaResumen.filter(value => value.moneda == "SOLES");
            var data_totalDolares = formValues.listaResumen.filter(value => value.moneda != "SOLES");


            if (data_totalSoles.length > 0 && totalSoles > 0) {
                formValues.listaAjuste.push({
                    id: global.fetchUniqueCode(),
                    idAperturaCaja: item.id,
                    moneda: data_totalSoles[0].moneda,
                    idMoneda: 1,
                    totalEfectivo: totalSoles,
                    totalCaja: 0,
                    totalfaltante: 0,
                    opcion: true,
                });

            }
            if (data_totalDolares.length > 0 && totalDolares > 0) {

                formValues.listaAjuste.push({
                    id: global.fetchUniqueCode(),
                    idAperturaCaja: item.id,
                    moneda: data_totalDolares[0].moneda,
                    idMoneda: 2,
                    totalEfectivo: totalDolares,
                    totalCaja: 0,
                    totalfaltante: 0,
                    opcion: true,
                });
            }





            this.setState({ viewCierreVisible: true, formValues });


        }
    }



    //#endregion END VIEW




    //#region LOAD  SERVICE OR CALL SERVICE

    async componentDidMount() {
        this._isMounted = true;

        var idUsuario = auth.user().id;
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: TESORERIA });

        this._initPagination(this.state.filter, arqueoCajaService.paginacion);

        const establecimientos = await establecimientoService.principales();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const cajas = await cajaService.listar();
        const empleados = await empleadoService.listar();
        const seriecorrelativo = await cajaAperturaService.Getcorrelativo();
        const efectivos = await cajaAperturaService.Getefectivo();
        const soles = efectivos.filter(m => m.id_Moneda === SOLES);
        const dolares = efectivos.filter(m => m.id_Moneda === DOLARES_AMERICANOS);
        const estado = await cajaService.listarEstado();



        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                listaEstablecimiento: establecimientos ? establecimientos : [],
                listaCaja: cajas ? cajas : [],
                listaEstado: estado ? estado : [],
                serie_correlativo: seriecorrelativo ? seriecorrelativo : {},
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                listaEmpleado: empleados ? empleados : [],
                listaEfectivoSoles: soles ? soles : [],
                listaEfectivoDolares: dolares ? dolares : [],
                configuraciones: configuraciones ? configuraciones : [],
            });
        }
    }

    //#endregion END  LOAD  SERVICE OR CALL SERVICE

    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return (
            <div>

                <Header
                    title="Arqueo de Caja"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.listaEstablecimiento}
                    cajas={this.state.listaCaja}
                    empleados={this.state.listaEmpleado}
                    estados={this.state.listaEstado}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    loadingClose={this.state.loadingSource}

                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onChange={this._handleChangePagination}
                    onViewCierre={this.handleViewCierre}
                    onImprimir={this.handleImprimir}
                    onAnexo={this.handleAnexo}

                />


                <CierreModal
                    visible={this.state.viewCierreVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewCierreVisible: false })}
                    onSave={this.handleCerrarCaja}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <AnexoModal
                    visible={this.state.viewAnexo}
                    pagination={this.state.paginationAnexo}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewAnexo: false })}
                    onExportExcel={this.handleExportExcelAnexo}
                    onChangePago={this.ChangePagination}


                />


            </div>
        )
    }

}